export default "__VITE_ASSET__08c9bb79__"